import './account-payments';
import './activity';
import './alerts';
import './app-version';
import './appointments';
import './artists';
import './auth';
import './appointments-list';
import './clients-list';
import './collector';
import './dashboard';
import './events';
import './file-uploads';
import './image';
import './invitation';
import './login';
import './message-templates';
import './messages';
import './notifications';
import './profile';
import './progress';
import './projects';
import './reset-password';
import './schedule';
import './shop';
import './signup';
import './stats';
import './styles';



// WEBPACK FOOTER //
// ./components/index.js